export function isBusinessUnauthorized(data) {
  return Number(data && data.code) === 401
}

export function isHttpUnauthorized(error) {
  return Number(error && error.response && error.response.status) === 401
}

export function createUnauthorizedHandler({clearSession, notify, redirectToLogin}) {
  let handling = false

  return context => {
    if (handling) return false

    handling = true
    try {
      clearSession(context)
      notify(context)
      Promise.resolve(redirectToLogin())
        .catch(() => {})
        .finally(() => {
          handling = false
        })
    } catch (error) {
      handling = false
      throw error
    }
    return true
  }
}
